/**
 * Formatea una fecha ISO a formato dd-mm-yyyy
 * @param isoDate - Fecha en formato ISO (e.j. "2025-03-26T14:56:08.221Z")
 * @returns string - Fecha formateada (e.j. "26-03-2025")
 */
export const formatDate = (isoDate: string): string => {
  const date = new Date(isoDate);

  // Obtener día, mes y año
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses van de 0-11
  const year = date.getFullYear();

  // Retornar en formato dd-mm-yyyy
  return `${day}-${month}-${year}`;
};
